import { SelectOption } from "features/ui/Select";

export const DEBOUNCE_DELAY = 200;
export const DEFAULT_LOAD_NUM_ITEMS = 10;
export const DEFAULT_DISABLE_ARBITRARY_TEXT = false;

export const SELECTED_TAGS_TO_SHOW = 1;
export const DEFAULT_WIDTH_PX = 250;
export const DEFAULT_APPEND_ARBITRARY_OPTION = true;

export const DEFAULT_FORMAT_FUNCTION = (options: SelectOption[]) => options;
export const DEFAULT_LOAD_OPTIONS_ARGS = {};
